import React from 'react';
import './newPerson.css';
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import ChooseUserOption from '../chooseUser/chooseUserOption/chooseUserOption';
import CustomInput from '../../../components/Elements/input/customInput';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import AcceptInput from '../accept/accept';
import CustomInputValue from '../../../components/Elements/inputWithValue/customInputValue'
import CustomLink from '../../../components/Elements/Link/link';
import { useState, useEffect } from 'react';
import ApiService from '../../../services/ApiService';
import * as globals from '../../../globals';

const NewPerson = (props) => {
    const [dataPattern, setDataPattern] = useState('dd-mm-yyyy');
    const [steps, setSteps] = useState(1);
    const apiService = ApiService.getInstance();
    const [formData, setFormData] = useState({
        ParticipantRelationsDVID: 0,
        firstName: '',
        lastName: '',
        // genderDVID: 0,
        // dateofbirdth: '',
        // pesel: '',
        // street: '',
        // building: '',
        // flat: '',
        // city: '',
        // postalcode: '',
        email: '',
        phone: '',
        personalDataProcessingConsent: 0,
        consentReceiveSmsEmailPhone:1,
        marketingAgreement:1,
        isAdult:true
    });
    //Adres osoby powiązanej jest taki sam jak mój.
    const [repeatedData, setRepeatedData] = useState({
        contact: true,
        adres: true,
    })
    const [formDataValidation, setFormDataValidation] = useState({
        firstName: true,
        lastName: true,
        // genderDVID: true,
        ParticipantRelationsDVID:true,
        // dateofbirdth: true,
        // pesel: true,
        // street: true,
        // building: true,
        // city: true,
        // postalcode: true,
        email: true,
        phone: true,
        personalDataProcessingConsent: true,
    });

    const [participantRelationsDVID, setParticipantRelationsDVID] = useState({
        rodzicem: false,
        opiekunem: false,
        rodzenstwem: false,
        dzieckiem: false,
    });
    const [genderDVID, setGenderDVID] = useState({
        man: false,
        woman: false,
        other: false,
    });
    const [bdDataFrompesel, setBDData] = useState("")
    function closeModal(e) {
        let isValid = true;

        for (var key in formData) {
  

            if (formData[key].length == 0) {
                if (key != 'ParticipantRelationsDVID' && key != 'flat' && key != 'genderDVID') {
                    formDataValidation[key] = false;
                }
            }
        }

        // if (formData.pesel.toString().length != 11) {
        //     formDataValidation['pesel'] = false;
        // } else {
        //     formDataValidation['pesel'] = true;
        // }
        if (formData.phone.toString().length != 9) {
  
            formDataValidation['phone'] = false;
        } else {
            formDataValidation['phone'] = true;
        }
        if (formData.ParticipantRelationsDVID != 0) {
          
            formDataValidation['ParticipantRelationsDVID'] = true;
        } else {
            formDataValidation['ParticipantRelationsDVID'] = false;
        }
        // if (formData.genderDVID != 0) {
  
        //     formDataValidation['genderDVID'] = true;
        // } else {
     
        //     formDataValidation['genderDVID'] = false;
        // }


        for (var key in formDataValidation) {
            if (key !="isAdult" &&!formDataValidation[key]) {
                
                isValid = false;
            }
        }

        if (isValid) {
            if (formData['personalDataProcessingConsent'] == 1) {
                save(e);
                // props.close();
            }
        }
    }

    function showCalendary(e){
      
        document.getElementById("calendary").showPicker();
    }

    function refresh() {
        
        props.onRefresh();
    }
    function moveToRodo(){
        const win = window.open("#/RODO", "_blank");
  win.focus();
       
    }
    function save(e) {
        e.preventDefault();

        apiService.apiPost('RegisterSubaccount', formData, (response) => {
            if (response.success) {
                const messageTxt = globals.getRegistrationTextByStatus(response.data.message);
                if (response.data.message == 'strUserRegistered') {
                    setSteps(3);
                    setFormData({
                        ParticipantRelationsDVID: 0,
                        firstName: '',
                        lastName: '',
                        // genderDVID: 0,
                        // dateofbirdth: '',
                        // pesel: '',
                        // street: '',
                        // building: '',
                        // flat: '',
                        // city: '',
                        // postalcode: '',
                        email: '',
                        phone: '',
                        personalDataProcessingConsent: 0,
                        consentReceiveSmsEmailPhone:1,
                        marketingAgreement:1,
                    })
                    refresh();
                } else if (response.data.message == 'strUserRegisteredAndConfirmed') {
                    setSteps(2);
                    setFormData({
                        ParticipantRelationsDVID: 0,
                        firstName: '',
                        lastName: '',
                        // genderDVID: 0,
                        // dateofbirdth: '',
                        // pesel: '',
                        // street: '',
                        // building: '',
                        // flat: '',
                        // city: '',
                        // postalcode: '',
                        email: '',
                        phone: '',
                        personalDataProcessingConsent: 0,
                        consentReceiveSmsEmailPhone:1,
                        marketingAgreement:1,
                    })
                    refresh();
                }
                else if (response.data.message == 'strBOKAnotherUserWithData') {
                    setSteps(4);
                    setFormData({
                        ParticipantRelationsDVID: 0,
                        firstName: '',
                        lastName: '',
                        // genderDVID: 0,
                        // dateofbirdth: '',
                        // pesel: '',
                        // street: '',
                        // building: '',
                        // flat: '',
                        // city: '',
                        // postalcode: '',
                        email: '',
                        phone: '',
                        personalDataProcessingConsent: 0,
                        consentReceiveSmsEmailPhone:1,
                        marketingAgreement:1,
                    })
                    refresh();
                } else if (response.data.message == 'strAnotherInactiveUser') {
                    setSteps(5);
                    setFormData({
                        ParticipantRelationsDVID: 0,
                        firstName: '',
                        lastName: '',
                        // genderDVID: 0,
                        // dateofbirdth: '',
                        // pesel: '',
                        // street: '',
                        // building: '',
                        // flat: '',
                        // city: '',
                        // postalcode: '',
                        email: '',
                        phone: '',
                        personalDataProcessingConsent: 0,
                        consentReceiveSmsEmailPhone:1,
                        marketingAgreement:1,
                    })
                    refresh();
                } else {
                    // if (response.data.message == 'strAnotherUserWithEmailOrPesel') {
                    // history.push('/osoba_powiazana_error');
                    // } else {
                
                    refresh();
                    // }
                }
            } else {
             
                refresh();
            }
        });
    }
    function PeselDecode(pesel) {
        var rok = parseInt(pesel.substring(0, 2), 10);
        var miesiac = parseInt(pesel.substring(2, 4), 10);
        var dzien = parseInt(pesel.substring(4, 6), 10);

        if (miesiac > 80) {
            rok = rok + 1800;
            miesiac = miesiac - 80;
        } else if (miesiac > 60) {
            rok = rok + 2200;
            miesiac = miesiac - 60;
        } else if (miesiac > 40) {
            rok = rok + 2100;
            miesiac = miesiac - 40;
        } else if (miesiac > 20) {
            rok = rok + 2000;
            miesiac = miesiac - 20;
        } else {
            rok += 1900;
        }
        // Daty sa ok. Teraz ustawiamy.
        if(miesiac < 10){
            miesiac = "0" + miesiac 
        }
        if(dzien < 10){
            dzien = "0" + dzien
        }
        var urodzony = rok + '-' + miesiac + '-' + dzien;
        document.getElementById("calendary").value = urodzony
        return urodzony
    }
    useEffect(()=>{
        setSteps(1)
    },[])

    return (
        <> 
        {steps == 5? <div className="contectetPerson_msg">
            <CustomTittle>Nie udało się dodać nowej osoby powiązanej</CustomTittle>
            <p className="text_conectedPerson error_conectedPerson">Podane imię, adres email lub numer telefonu został już wykorzystany do utworzenia konta. Na podany adres została wysłana wiadomość z linkiem aktywacyjnym. Aktywuj je a następnie odśwież strone Procesu zakupowego.</p>
            <CustomButtons
                clickFunction={(e) => {
                    setSteps(1)
                }}
                classButton="solid"
                size="big"
            >
                Dodaj kolejną osobę 
            </CustomButtons>
            </div>:""} 
        {steps == 4? <div className="contectetPerson_msg">
            <CustomTittle>Nie udało się dodać nowej osoby powiązanej</CustomTittle>
            <p className="text_conectedPerson error_conectedPerson">Podany adres email lub numer telefonu został już wykorzystany do utworzenia konta innego niż twoje.Skontaktuj się z Biurem obsługi klienta w celu dalszych wyjaśnień.</p>
            <CustomButtons
                clickFunction={(e) => {
                    setSteps(1)
                }}
                classButton="solid"
                size="big"
            >
                Dodaj kolejną osobę 
            </CustomButtons>
            </div>:""}
            {steps == 3? <div className="contectetPerson_msg">
            <CustomTittle>Osoba powiązana została pomyślnie dodana.</CustomTittle>
            <p className="text_conectedPerson">Na twoją skrzynkę e-mail została wysłana wiadomość z linkiem aktywacyjnym. Aktywuj konto a następnie odśwież strone Procesu zakupowego</p>
            <CustomButtons
                clickFunction={(e) => {
                    setSteps(1)
                }}
                classButton="solid"
                size="big"
            >
                Dodaj kolejną osobę 
            </CustomButtons>
            </div>:""}
            {steps == 2? <div className="contectetPerson_msg">
            <CustomTittle>Osoba powiązana została pomyślnie dodana</CustomTittle>
            <CustomButtons
                clickFunction={(e) => {
                    setSteps(1)
                }}
                classButton="solid"
                size="big"
            >
                Dodaj kolejną osobę 
            </CustomButtons>
            </div>:""}
           {steps == 1? <div className="newPerson_wrapper">
                <CustomTittle>Dodaj osobę powiązaną</CustomTittle>
                <div className="chooseConection">
                    <p>Kim jesteś dla dodawanej osoby?</p>
                    <ChooseUserOption
                        isChekcked={participantRelationsDVID.rodzicem}
                        onCheck={(e) => {
                            formDataValidation['ParticipantRelationsDVID'] = true;
                            setFormData({
                                ...formData,
                                ...{ ParticipantRelationsDVID: 2 },
                            });
                            setParticipantRelationsDVID({
                                rodzicem: true,
                                opiekunem: false,
                                rodzenstwem: false,
                                dzieckiem: false,
                            });
                            
                        }}
                        label="Rodzicem"
                    ></ChooseUserOption>
                    <ChooseUserOption
                        isChekcked={participantRelationsDVID.opiekunem}
                        onCheck={(e) => {
                            formDataValidation['ParticipantRelationsDVID'] = true;
                            setFormData({
                                ...formData,
                                ...{ ParticipantRelationsDVID: 1 },
                            });
                            setParticipantRelationsDVID({
                                rodzicem: false,
                                opiekunem: true,
                                rodzenstwem: false,
                                dzieckiem: false,
                            });
                        }}
                        label="Opiekunem"
                    ></ChooseUserOption>
                    <ChooseUserOption
                        isChekcked={participantRelationsDVID.rodzenstwem}
                        onCheck={(e) => {
                            formDataValidation['ParticipantRelationsDVID'] = true;
                            setFormData({
                                ...formData,
                                ...{ ParticipantRelationsDVID: 3 },
                            });
                            setParticipantRelationsDVID({
                                rodzicem: false,
                                opiekunem: false,
                                rodzenstwem: true,
                                dzieckiem: false,
                            });
                        }}
                        label="Rodzeństwem/Partnerem"
                    ></ChooseUserOption>
                {!formDataValidation.ParticipantRelationsDVID?<p className="msgInvalid">*Uzupełnij wymagane pole</p>:""}
                </div>
                <div className="chooseConection">
                    <p>Podaj dane dodawanej osoby</p>
                    <CustomInput
                        isRequied={true}
                        validation={formDataValidation['firstName']}
                        showCalendary={() => {
                            if (!formDataValidation['firstName']) {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ firstName: true },
                                });
                            }
                        }}
                        onChangeInput={(e) => {
                            if (!formDataValidation['firstName']) {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ firstName: true },
                                });
                            }
                            let value = e.trim();
                            if (value.length != 0) {
                                setFormData({
                                    ...formData,
                                    ...{ firstName: value },
                                });
                            } else {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ firstName: false },
                                });
                            }
                        }}
                        title="Imię"
                    ></CustomInput>
                    <p className="fullName">Wpisz pełne imię</p>
                    <CustomInput
                        isRequied={true}
                        validation={formDataValidation['lastName']}
                        showCalendary={() => {
                            if (!formDataValidation['lastName']) {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ lastName: true },
                                });
                            }
                        }}
                        onChangeInput={(e) => {
                            if (!formDataValidation['lastName']) {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ lastName: true },
                                });
                            }
                            let value = e.trim();
                            if (value.length != 0) {
                                setFormData({
                                    ...formData,
                                    ...{ lastName: value },
                                });
                            } else {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ lastName: false },
                                });
                            }
                        }}
                        title="Nazwisko"
                    ></CustomInput>
                </div>
                {/* <div className="chooseConection">
                    <p>Płeć</p>
                    <ChooseUserOption
                        isChekcked={genderDVID.woman}
                        onCheck={(e) => {
                            formDataValidation['genderDVID'] = true;
                            setFormData({
                                ...formData,
                                ...{ genderDVID: 2 },
                            });
                            setGenderDVID({
                                man: false,
                                woman: true,
                                other: false,
                            });
                        }}
                        label="Kobieta"
                    ></ChooseUserOption>
                    <ChooseUserOption
                        isChekcked={genderDVID.man}
                        onCheck={(e) => {
                            formDataValidation['genderDVID'] = true;
                            setFormData({
                                ...formData,
                                ...{ genderDVID: 1 },
                            });
                            setGenderDVID({
                                man: true,
                                woman: false,
                                other: false,
                            });
                        }}
                        label="Mężczyzna"
                    ></ChooseUserOption>
                    <ChooseUserOption
                        isChekcked={genderDVID.other}
                        onCheck={(e) => {
                            formDataValidation['genderDVID'] = true;
                            setFormData({
                                ...formData,
                                ...{ genderDVID: 3 },
                            });
                            setGenderDVID({
                                man: false,
                                woman: false,
                                other: true,
                            });
                        }}
                        label="Nie chcę podawać"
                    ></ChooseUserOption>
                     {!formDataValidation.genderDVID?<p className="msgInvalid">*Uzupełnij wymagane pole</p>:""}
                </div> */}
                {/* <div className="chooseConection">
                    <CustomInput
                        validation={formDataValidation['pesel']}
                        isRequied={true}
                        showCalendary={() => {
                            if (!formDataValidation['pesel']) {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ pesel: true },
                                });
                            }
                        }}
                        onChangeInput={(e) => {
                            if (!formDataValidation['pesel']) {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ pesel: true, dateofbirdth: true },
                                });
                            }
                            let value = e.replaceAll(' ', '');
                            if (/^\d+$/.test(value) && value.length == 11) {
                                let bd = PeselDecode(value)
                                console.log(value)
                                setFormData({
                                    ...formData,
                                    ...{ pesel: value, dateofbirdth: bd },
                                });
                            } else {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ pesel: false },
                                });
                            }
                        }}
                        title="Pesel"
                    ></CustomInput>
                    <CustomInput
                    id="calendary"
                    icon={<svg onClick={showCalendary} width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.06847 13.9347H4.99777C4.52668 13.9347 4.14983 14.3115 4.14983 14.7826V14.8768C4.14983 15.3479 4.52668 15.7248 4.99777 15.7248H5.06847C5.53956 15.7248 5.91641 15.3479 5.91641 14.8768V14.7826C5.91641 14.3115 5.53956 13.9347 5.06847 13.9347Z" fill="#CC0033"/>
                    <path d="M8.50746 13.9347H8.43677C7.96567 13.9347 7.58882 14.3115 7.58882 14.7826V14.8768C7.58882 15.3479 7.96567 15.7248 8.43677 15.7248H8.50746C8.97855 15.7248 9.35541 15.3479 9.35541 14.8768V14.7826C9.35541 14.3115 8.97855 13.9347 8.50746 13.9347Z" fill="#CC0033"/>
                    <path d="M11.97 13.9347H11.8758C11.4047 13.9347 11.0278 14.3115 11.0278 14.7826V14.8768C11.0278 15.3479 11.4047 15.7248 11.8758 15.7248H11.97C12.4411 15.7248 12.8179 15.3479 12.8179 14.8768L12.818 14.7826C12.818 14.3115 12.4411 13.9347 11.97 13.9347Z" fill="#CC0033"/>
                    <path d="M5.06847 10.4486H4.99777C4.52668 10.4486 4.14983 10.8254 4.14983 11.2965V11.3907C4.14983 11.8618 4.52668 12.2387 4.99777 12.2387H5.06847C5.53956 12.2387 5.91641 11.8618 5.91641 11.3907V11.2965C5.91641 10.8254 5.53956 10.4486 5.06847 10.4486Z" fill="#CC0033"/>
                    <path d="M8.50746 10.4486H8.43677C7.96567 10.4486 7.58882 10.8254 7.58882 11.2965V11.3907C7.58882 11.8618 7.96567 12.2387 8.43677 12.2387H8.50746C8.97855 12.2387 9.35541 11.8618 9.35541 11.3907V11.2965C9.35541 10.8254 8.97855 10.4486 8.50746 10.4486Z" fill="#CC0033"/>
                    <path d="M11.97 10.4486H11.8758C11.4047 10.4486 11.0278 10.8254 11.0278 11.2965V11.3907C11.0278 11.8618 11.4047 12.2387 11.8758 12.2387H11.97C12.4411 12.2387 12.8179 11.8618 12.8179 11.3907V11.2965C12.818 10.8254 12.4411 10.4486 11.97 10.4486Z" fill="#CC0033"/>
                    <path d="M15.4089 13.9347H15.3147C14.8436 13.9347 14.4668 14.3115 14.4668 14.7826V14.8768C14.4668 15.3479 14.8436 15.7248 15.3147 15.7248H15.4089C15.88 15.7248 16.2569 15.3479 16.2569 14.8768V14.7826C16.2804 14.3115 15.88 13.9347 15.4089 13.9347Z" fill="#CC0033"/>
                    <path d="M18.8714 13.9347H18.7772C18.3061 13.9347 17.9293 14.3115 17.9293 14.7826V14.8768C17.9293 15.3479 18.3061 15.7248 18.7772 15.7248H18.8714C19.3425 15.7248 19.7194 15.3479 19.7194 14.8768V14.7826C19.7194 14.3115 19.3425 13.9347 18.8714 13.9347Z" fill="#CC0033"/>
                    <path d="M15.4089 10.4486H15.3147C14.8436 10.4486 14.4668 10.8254 14.4668 11.2965V11.3907C14.4668 11.8618 14.8436 12.2387 15.3147 12.2387H15.4089C15.88 12.2387 16.2569 11.8618 16.2569 11.3907V11.2965C16.2804 10.8254 15.88 10.4486 15.4089 10.4486Z" fill="#CC0033"/>
                    <path d="M18.8714 10.4486H18.7772C18.3061 10.4486 17.9293 10.8254 17.9293 11.2965V11.3907C17.9293 11.8618 18.3061 12.2387 18.7772 12.2387H18.8714C19.3425 12.2387 19.7194 11.8618 19.7194 11.3907V11.2965C19.7194 10.8254 19.3425 10.4486 18.8714 10.4486Z" fill="#CC0033"/>
                    <path d="M5.06847 17.3972H4.99777C4.52668 17.3972 4.14983 17.774 4.14983 18.2451V18.3393C4.14983 18.8104 4.52668 19.1873 4.99777 19.1873H5.06847C5.53956 19.1873 5.91641 18.8104 5.91641 18.3393V18.2451C5.91641 17.7976 5.53956 17.3972 5.06847 17.3972Z" fill="#CC0033"/>
                    <path d="M8.50746 17.3972H8.43677C7.96567 17.3972 7.58882 17.774 7.58882 18.2451V18.3393C7.58882 18.8104 7.96567 19.1873 8.43677 19.1873H8.50746C8.97855 19.1873 9.35541 18.8104 9.35541 18.3393V18.2451C9.35541 17.7976 8.97855 17.3972 8.50746 17.3972Z" fill="#CC0033"/>
                    <path d="M11.97 17.3972H11.8758C11.4047 17.3972 11.0278 17.774 11.0278 18.2451V18.3393C11.0278 18.8104 11.4047 19.1873 11.8758 19.1873H11.97C12.4411 19.1873 12.8179 18.8104 12.8179 18.3393V18.2451C12.818 17.7976 12.4411 17.3972 11.97 17.3972Z" fill="#CC0033"/>
                    <path d="M15.4089 17.3972H15.3147C14.8436 17.3972 14.4668 17.774 14.4668 18.2451V18.3393C14.4668 18.8104 14.8436 19.1873 15.3147 19.1873H15.4089C15.88 19.1873 16.2569 18.8104 16.2569 18.3393V18.2451C16.2804 17.7976 15.88 17.3972 15.4089 17.3972Z" fill="#CC0033"/>
                    <path d="M18.8714 17.3972H18.7772C18.3061 17.3972 17.9293 17.774 17.9293 18.2451V18.3393C17.9293 18.8104 18.3061 19.1873 18.7772 19.1873H18.8714C19.3425 19.1873 19.7194 18.8104 19.7194 18.3393V18.2451C19.7194 17.7976 19.3425 17.3972 18.8714 17.3972Z" fill="#CC0033"/>
                    <path d="M23.1113 7.69266V5.78476C23.1113 4.32441 21.9336 3.14664 20.4967 3.14664H19.107V2.32224C19.107 1.30935 18.2826 0.48494 17.2697 0.48494C16.2568 0.48494 15.4324 1.30935 15.4324 2.32224V3.14664L8.46025 3.14657V2.32216C8.46025 1.30927 7.63584 0.484863 6.62296 0.484863C5.61007 0.484863 4.78566 1.30927 4.78566 2.32216V3.14657H3.39592C1.93558 3.14657 0.757812 4.3243 0.757812 5.78468V19.8703C0.757812 21.3071 1.93554 22.4849 3.39592 22.4849H20.5201C21.9569 22.4849 23.1346 21.3071 23.1346 19.8703L23.1113 7.69266ZM16.516 2.32222C16.516 1.92183 16.8458 1.59204 17.2462 1.59204C17.6466 1.59204 17.9764 1.92183 17.9764 2.32222V4.06527C17.9764 4.46566 17.6466 4.79544 17.2462 4.79544C16.8458 4.79544 16.516 4.46566 16.516 4.06527V2.32222ZM5.86935 2.32222C5.86935 1.92183 6.19913 1.59204 6.59952 1.59204C6.99991 1.59204 7.32969 1.92183 7.32969 2.32222V4.06527C7.32969 4.46566 6.99991 4.79544 6.59952 4.79544C6.19913 4.79544 5.86935 4.46566 5.86935 4.06527V2.32222ZM3.37256 4.25373H4.78584C4.88007 5.17238 5.65732 5.90255 6.62313 5.90255C7.56532 5.90255 8.34266 5.17238 8.4368 4.25373H15.4325C15.5267 5.17238 16.304 5.90255 17.2462 5.90255C18.1883 5.90255 18.9657 5.17238 19.0598 4.25373H20.4731C21.2975 4.25373 21.9806 4.93683 21.9806 5.78477V7.15098L1.84146 7.1509V5.7847C1.84146 4.93675 2.52462 4.25373 3.37256 4.25373ZM20.4967 21.3779H3.37256C2.52462 21.3779 1.84152 20.6948 1.84152 19.8704V8.23443H22.0042V19.8704C22.0043 20.6948 21.3211 21.3779 20.4967 21.3779Z" fill="#CC0033"/>
                    </svg>
                    }
                        validation={formDataValidation['dateofbirdth']}
                        pattern="dd.mm.rrrr"
                        placholder={dataPattern}
                        onChangeInput={(e) => {
                            console.log("-----", e)
                            let value = e.trim();
                            if (!formDataValidation['dateofbirdth']) {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ dateofbirdth: true },
                                });
                            }
                            if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(value)) {
                                setFormData({
                                    ...formData,
                                    ...{ dateofbirdth: value },
                                });
                            } else {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ dateofbirdth: false },
                                });
                            }
                        }}
                        showCalendary={(e) => {
                            console.log("-----", e)
                            e.target.showPicker();
                            if (!formDataValidation['dateofbirdth']) {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ dateofbirdth: true },
                                });
                            }
                        }}
                        type="date"
                        isRequied={true}
                        title="Data urodzenia"
                    ></CustomInput>
                    {/* <ChooseUserOption
                        isChekcked={repeatedData.contact}
                        onCheck={(e) => {
                            setRepeatedData(
                                {...repeatedData,
                                    contact: !repeatedData.contact}
                            )
                        }}
                        label="Dane kontaktowe osoby powiązanej jest taki sam jak mój."
                    ></ChooseUserOption> */}
                    <div className="row_input">
                        <CustomInput
                            validation={formDataValidation['street']}
                            size="small"
                            showCalendary={() => {
                                if (!formDataValidation['street']) {
                                    setFormDataValidation({
                                        ...formDataValidation,
                                        ...{ street: true },
                                    });
                                }
                            }}
                            onChangeInput={(e) => {
                                if (!formDataValidation['street']) {
                                    setFormDataValidation({
                                        ...formDataValidation,
                                        ...{ street: true },
                                    });
                                }
                                let value = e.trim();
                                if (value.length != 0) {
                                    setFormData({
                                        ...formData,
                                        ...{ street: value },
                                    });
                                } else {
                                    setFormDataValidation({
                                        ...formDataValidation,
                                        ...{ street: false },
                                    });
                                }
                            }}
                            isRequied={true}
                            title="Ulica"
                        ></CustomInput>
                        <CustomInput
                            validation={formDataValidation['building']}
                            showCalendary={() => {
                                if (!formDataValidation['building']) {
                                    setFormDataValidation({
                                        ...formDataValidation,
                                        ...{ building: true },
                                    });
                                }
                            }}
                            size="small"
                            onChangeInput={(e) => {
                                if (!formDataValidation['building']) {
                                    setFormDataValidation({
                                        ...formDataValidation,
                                        ...{ building: true },
                                    });
                                }
                                let building = e.split('/')[0];
                                let flat = e.split('/')[1] == undefined ? '' : e.split('/')[1];

                                let value = building;
                                if (value.length != 0) {
                                    setFormData({
                                        ...formData,
                                        ...{ building: parseInt(value), flat: flat },
                                    });
                                } else {
                                    setFormDataValidation({
                                        ...formDataValidation,
                                        ...{ building: false },
                                    });
                                }
                            }}
                            pattern="/"
                            isRequied={true}
                            title="Nr domu/mieszkania"
                        ></CustomInput>
                    </div> */}
                    {/* <div className="row_input">
                        <CustomInput
                            validation={formDataValidation['postalcode']}
                            showCalendary={() => {
                                if (!formDataValidation['postalcode']) {
                                    setFormDataValidation({
                                        ...formDataValidation,
                                        ...{ postalcode: true },
                                    });
                                }
                            }}
                            size="small"
                            onChangeInput={(e) => {
                                if (!formDataValidation['postalcode']) {
                                    setFormDataValidation({
                                        ...formDataValidation,
                                        ...{ postalcode: true },
                                    });
                                }

                                let value = e.trim();
                                if (/^[0-9]{2}-[0-9]{3}/.test(value)) {
                                    setFormData({
                                        ...formData,
                                        ...{ postalcode: value },
                                    });
                                } else {
                                    setFormDataValidation({
                                        ...formDataValidation,
                                        ...{ postalcode: false },
                                    });
                                }
                            }}
                            isRequied={true}
                            title="Kod pocztowy"
                        ></CustomInput>
                        <CustomInput
                            showCalendary={() => {
                                if (!formDataValidation['city']) {
                                    setFormDataValidation({
                                        ...formDataValidation,
                                        ...{ city: true },
                                    });
                                }
                            }}
                            validation={formDataValidation['city']}
                            size="small"
                            onChangeInput={(e) => {
                                if (!formDataValidation['city']) {
                                    setFormDataValidation({
                                        ...formDataValidation,
                                        ...{ city: true },
                                    });
                                }
                                let value = e.trim();
                                if (value.length != 0) {
                                    setFormData({
                                        ...formData,
                                        ...{ city: value },
                                    });
                                } else {
                                    setFormDataValidation({
                                        ...formDataValidation,
                                        ...{ city: false },
                                    });
                                }
                            }}
                            isRequied={true}
                            title="Miejscowość"
                        ></CustomInput>
                    </div> */}
                   <CustomInput
                        showCalendary={() => {
                            if (!formDataValidation['phone']) {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ phone: true },
                                });
                            }
                        }}
                        validation={formDataValidation['phone']}
                        isRequied={true}
                        onChangeInput={(e) => {
                            if (!formDataValidation['phone']) {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ phone: true },
                                });
                            }
                            let value = e.replaceAll(' ', '');
                            if (/^\d+$/.test(value) && value.length == 9) {
                                setFormData({
                                    ...formData,
                                    ...{ phone: parseInt(value) },
                                });
                            } else {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ phone: false },
                                });
                            }
                        }}
                        title="Telefon"
                    ></CustomInput>
                    <CustomInput
                        showCalendary={() => {
                            if (!formDataValidation['email']) {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ email: true },
                                });
                            }
                        }}
                        onChangeInput={(e) => {
                            if (!formDataValidation['email']) {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ email: true },
                                });
                            }
                            let value = e.replaceAll(' ', '');
                            const regexExp =
                                /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;

                            if (regexExp.test(value)) {
                                setFormData({
                                    ...formData,
                                    ...{ email: value },
                                });
                            } else {
                                setFormDataValidation({
                                    ...formDataValidation,
                                    ...{ email: false },
                                });
                            }
                        }}
                        isRequied={true}
                        validation={formDataValidation['email']}
                        title="E-mail"
                    ></CustomInput>
                    <div className="chooseConection">
                    <p>Czy osoba powiązana jest osobą pełnoletnią?</p>
                    <ChooseUserOption
                        isChekcked={formData.isAdult}
                        onCheck={(e) => {
                            setFormData({...formData, ...{isAdult: true}})
                        }}
                        label="Tak"
                    ></ChooseUserOption>
                    <ChooseUserOption
                        isChekcked={!formData.isAdult}
                        onCheck={(e) => {
                            setFormData({...formData, ...{isAdult: false}})
                        }}
                        label="Nie"
                    ></ChooseUserOption>
                </div></div>
            :""}
           {steps == 1? <div className="acceptSection">
                <div className="labelDiv">
                    <AcceptInput
                        onAccept={(e) => {
                            if (e) {
                                setFormData({
                                    ...formData,
                                    ...{ personalDataProcessingConsent: 0 },
                                });
                            } else {
                                setFormData({
                                    ...formData,
                                    ...{ personalDataProcessingConsent: 1 },
                                });
                            }
                        }}
                        label="Akceptuję klauzulę informacyjną RODO"
                    />
                    <p onClick={moveToRodo} className="hintTextDot">?</p>
                </div>
            </div>:""}
            {steps == 1?<CustomButtons
                clickFunction={(e) => {
                    closeModal(e);
                }}
                classButton="solid"
                size="big"
            >
                ZATWIERDŹ
            </CustomButtons>:""}
        </>
    );
};

export default NewPerson;
